import { auditConstants, auditLogsConstants } from "../../constants/AdministrationConstants";

const defaultState = {
  items: [],
  loadingItems: false,
  fetchedItems: false,
  error: null,
};

function normalData(arr) {
  if (!Array.isArray(arr)) return [];

  // Вспомогательная функция для расшифровки действия
  const getActionName = (actionCode) => {
    switch (actionCode) {
      case 1: return "Создание";
      case 2: return "Обновление";
      case 3: return "Удаление";
      case 4: return "Архивация";
      case 5: return "Разархивация";
      default: return "Неизвестно";
    }
  };

  return arr.map((elem, index) => ({
    ...elem,
    index: index + 1,
    timeCreated: elem.time,
    actionLabel: getActionName(elem.action),
    // Объединяем имя и почту для удобного вывода в одну колонку
    userDisplay: `${elem.userName} (${elem.userEmail})`,
  }));
}

export const auditReducer = function (state = defaultState, action) {
  switch (action.type) {
    case auditLogsConstants.GETALL_REQUEST_AUDIT:
      return { ...state, loadingItems: true, fetchedItems: false, error: null };
    case auditLogsConstants.GETALL_SUCCESS_AUDIT:
      return { ...state, items: normalData(action.response), loadingItems: false, fetchedItems: true };
    case auditLogsConstants.GETALL_FAILURE_AUDIT:
      return { ...state, loadingItems: false, error: action.error };
    default:
      return state;
  }
};